import { create } from 'zustand';
import { testConnection } from '../services/api';

export const useAppStore = create((set) => ({
  // State
  isOnline: navigator.onLine,
  networkCheckInterval: null,
  
  // Actions
  setOnlineStatus: (status) => set({ isOnline: status }),
  
  // Listen for online/offline events
  setupNetworkListeners: () => {
    const checkConnectivity = async () => {
      const testResponse = await testConnection();
      if (testResponse) {
        set({ isOnline: true });
        return;
      }
      
      set({ isOnline: false });
    };
    
    const handleOnline = () => {
      // When browser says we're online, verify it
      setTimeout(checkConnectivity, 10000);
    };
    
    const handleOffline = () => set({ isOnline: false });
    
    // Event listeners
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    
    // Periodic checks
    const interval = setInterval(checkConnectivity, 15000);
    set({ networkCheckInterval: interval });
    
    // Initial check
    checkConnectivity();
    
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      clearInterval(interval);
    };
  }
}));